import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppComponent } from "./app.component";
import { routing } from "./app-routing.module";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { httpInterceptProviders } from "./shared/services/auth-interceptor-provider.service";
import { MDBBootstrapModule } from "angular-bootstrap-md";
import { NgxsModule } from "@ngxs/store";
import { NgxsReduxDevtoolsPluginModule } from "@ngxs/devtools-plugin";
import { NgxsLoggerPluginModule } from "@ngxs/logger-plugin";
import { CurrentBidDataState } from "./shared/utility/states/currentBidData.state";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "../environments/environment";
import { CrewbidHelper } from "./shared/utility/helper";
import { GlobalStore } from "./shared/utility/store-operations";
import { ColumnDefinitionState } from "./shared/utility/states/columnDefinition.state";
import { UserDataState } from "./shared/utility/states/userData.state";
import { DexieOperations } from "./shared/utility/dexie-operation";
import { CrewbidCollection } from "./shared/utility/crewbid-collection";
import { BidListDataState } from "./shared/utility/states/bidListData.state";
import {
  LoginRouteGuard,
  RegistrationGuard,
  HomeGuard,
  BidlineGuard,
  PrivacyPolicyGuard
} from "./shared/utility/RoutingGuard";
import { ngxLoadingAnimationTypes, NgxLoadingModule } from "ngx-loading";
import {MatRadioModule} from '@angular/material/radio';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatCardModule} from '@angular/material/card';
import {MatTableModule} from '@angular/material/table';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { VacColumnDefinitionState } from "./shared/utility/states/vacColumnDefinition.state";
import { privacyPolicyRouting } from "./modules/privacy-policy/privacy-policy-routing.module";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        routing,
        NgxsModule.forRoot([
            CurrentBidDataState,
            ColumnDefinitionState,
            VacColumnDefinitionState,
            UserDataState,
            BidListDataState,
        ]),
        NgxsReduxDevtoolsPluginModule.forRoot(),
        NgxsLoggerPluginModule.forRoot({
            collapsed: false,
            disabled: environment.production,
        }),
        MDBBootstrapModule.forRoot(),
        NgxLoadingModule.forRoot({
            animationType: ngxLoadingAnimationTypes.chasingDots,
        }),
        MatCardModule,
        MatTableModule,
        MatInputModule,
        MatButtonModule,
        MatFormFieldModule,
        MatRadioModule,
        MatCheckboxModule,
        MatSnackBarModule,
        ServiceWorkerModule.register("ngsw-worker.js", {
            enabled: environment.production,
        }),
        MatDatepickerModule,
        MatNativeDateModule], providers: [
        httpInterceptProviders,
        CrewbidHelper,
        GlobalStore,
        DexieOperations,
        CrewbidCollection,
        LoginRouteGuard,
        RegistrationGuard,
        HomeGuard,
        BidlineGuard,
        PrivacyPolicyGuard,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
